export const formatDateAcc = (dateStr) => {
  const [day, month, year] = dateStr.split('-');
  return `${year}-${month}-${day}`;
};

export const toDisplayDate = (dateStr)=> {
  const [year, month, day] = dateStr.split("-");
  return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
} 
